<template>
  <Disclosure as="nav" class="bg-white" v-slot="{ open }">
    <div class="max-w-6xl px-4 py-2 mx-auto md:px-0">
      <div class="relative flex items-center justify-between h-16">
        <div
          class="flex items-center justify-center flex-1 sm:items-stretch sm:justify-start"
        >
          <div class="flex items-center flex-shrink-0">
            <a
              href="/"
              @click="setActiveLink('home')"
              class="w-36 text-primary hover:font-medium"
            >
              <img
                v-if="settings"
                :src="settings.photo"
                class="w-full h-full"
                alt=""
              />
            </a>
          </div>
          <div class="items-center hidden md:flex sm:ml-6 sm:block">
            <div class="flex items-center space-x-4">
              <router-link
                :to="{
                  name: 'properties',
                  params: { slug: 'properties-for-sale' },
                }"
                @click="setActiveLink('buy')"
                :class="{ 'active-link': activeLink === 'buy' }"
                class="nav-link hover:text-secondary"
                >Buy</router-link
              >
              <router-link
                :to="{
                  name: 'properties',
                  params: { slug: 'properties-for-rent' },
                }"
                @click="setActiveLink('rent')"
                :class="{ 'active-link': activeLink === 'rent' }"
                class="nav-link hover:text-secondary"
                >Rent</router-link
              >
              <router-link
                :to="{
                  name: 'properties',
                  params: { slug: 'properties-for-short-stay' },
                }"
                @click="setActiveLink('shortStay')"
                :class="{ 'active-link': activeLink === 'shortStay' }"
                class="nav-link hover:text-secondary"
                >Short stay</router-link
              >
              <router-link
                :to="{
                  name: 'properties',
                  params: { slug: 'commercial-properties' },
                }"
                @click="setActiveLink('commercial')"
                :class="{ 'active-link': activeLink === 'commercial' }"
                class="nav-link hover:text-secondary"
                >Commercial</router-link
              >
              <router-link
                to="/new-projects"
                @click="setActiveLink('new-projects')"
                :class="{ 'active-link': activeLink === 'new-projects' }"
                class="nav-link hover:text-secondary"
                >New projects</router-link
              >
              <router-link
                to="/find-broker"
                @click="setActiveLink('find-broker')"
                :class="{ 'active-link': activeLink === 'find-broker' }"
                class="nav-link hover:text-secondary"
                >Find agent</router-link
              >
              <!-- <router-link
                to="/mortgage"
                @click="setActiveLink('mortgage')"
                :class="{ 'active-link': activeLink === 'mortgage' }"
                class="nav-link hover:text-secondary"
                >Mortgage</router-link
              > -->
            </div>
          </div>
        </div>
        <div
          class="absolute inset-y-0 right-0 flex items-center space-x-4 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
        >
          <Menu v-if="isAuthenticated" as="div" class="relative">
            <div>
              <MenuButton
                class="relative flex text-sm bg-gray-800 border-0 rounded-full"
              >
                <span class="absolute -inset-1.5" />
                <span class="sr-only">Open user menu</span>
                <div
                  class="flex items-center justify-center w-8 h-8 text-white rounded-full bg-secondary"
                >
                  {{ $getInitials(state.user.name) }}
                </div>
              </MenuButton>
            </div>
            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <MenuItems
                class="absolute right-0 z-50 w-48 py-1 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
              >
                <MenuItem v-slot="{ active }">
                  <a
                    href="/profile"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'block px-4 py-2 text-sm text-gray-700',
                    ]"
                    >Your Profile</a
                  >
                </MenuItem>
                <MenuItem v-slot="{ active }">
                  <button
                    @click="logout"
                    :class="[
                      active
                        ? 'bg-gray-100 text-start w-full'
                        : ' text-start w-full',
                      'block px-4 py-2 text-start text-sm w-full text-gray-700',
                    ]"
                  >
                    Sign out
                  </button>
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
          <div v-else class="flex items-center space-x-4">
            <button
              @click="openViewModal('register')"
              class="bg-primary hover:bg-transparent border-primary border w-[96px] h-[36px] md:flex hidden justify-center items-center rounded text-white hover:text-primary text-sm"
            >
              Register
            </button>
            <button
              @click="openViewModal('login')"
              class="bg-transparent border-stone-300 hover:text-white hover:bg-secondary border px-3 h-[36px] md:flex hidden justify-center items-center text-secondary hover:border-secondary rounded text-sm"
            >
              Log in
            </button>
          </div>

          <!-- Profile dropdown -->
        </div>
        <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
          <DisclosureButton
            @click="openSidebar"
            class="relative inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
          >
            <span class="absolute -inset-0.5" />
            <span class="sr-only">Open main menu</span>
            <Bars3Icon v-if="!open" class="block w-6 h-6" aria-hidden="true" />
            <XMarkIcon v-else class="block w-6 h-6" aria-hidden="true" />
          </DisclosureButton>
        </div>
      </div>
    </div>
    <hr />
  </Disclosure>
  <Modal
    :showViewModal="showLoginModal"
    :modalType="modalType"
    @closeViewModal="closeModal"
    @switchModalType="handleSwitchModalType"
  />
  <Sidebar />
</template>
<script>
export default {
  name: "HeaderView",
};
</script>
<script setup>
import { ref, watch, onMounted } from "vue";
import Modal from "@/components/LoginModal.vue";
import Sidebar from "@/layouts/MobileMenu.vue";
import { useStore } from "vuex";
import {
  Disclosure,
  DisclosureButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";
import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";
import useAuth from "@/composables/useAuth";

const { state, logout } = useAuth();
const isAuthenticated = ref(state.isAuthenticated);

watch(
  () => state.isAuthenticated,
  (newVal) => {
    isAuthenticated.value = newVal;
  }
);
// const mobileMenuOpen = ref(false);
const store = useStore();
const settings = ref("");
const activeLink = ref(sessionStorage.getItem("activeLink") || "");
const showLoginModal = ref(false);
const modalType = ref("");

const loadSettings = async () => {
  await store.dispatch("fetchSettings");
  settings.value = store.state.settings.data;
  // console.log(settings.value);
};

const openViewModal = (type) => {
  showLoginModal.value = true;
  modalType.value = type;
};

const openSidebar = () => {
  store.dispatch("openSidebar");
};

const closeModal = () => {
  showLoginModal.value = false;
  modalType.value = "";
};

const setActiveLink = (link) => {
  activeLink.value = link;
  sessionStorage.setItem("activeLink", link);
};

const handleSwitchModalType = (type) => {
  modalType.value = type;
};

onMounted(() => {
  loadSettings();
  const storedLink = sessionStorage.getItem("activeLink");
  if (storedLink) {
    activeLink.value = storedLink;
  }
});
</script>

<style scoped>
/* CSS */
.nav-link {
  transition: font-weight 0.2s ease;
  color: #606060;
  font-size: 14.5px;
  font-weight: 400;
}
.active-link {
  font-weight: bold !important;
  color: #c01823 !important;
}
</style>
